export default "__VITE_ASSET__BoN3iyF7__"